export var PaymentProvider;
(function (PaymentProvider) {
    PaymentProvider["Mollie"] = "Mollie";
    PaymentProvider["Payconiq"] = "Payconiq";
    PaymentProvider["Buckaroo"] = "Buckaroo";
    PaymentProvider["Stripe"] = "Stripe";
})(PaymentProvider || (PaymentProvider = {}));
//# sourceMappingURL=PaymentProvider.js.map